var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 263.38 263.38",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:#CDEAE8;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.01,188.31c1.53-30.57,3.67-84.38,3.67-84.38s-0.51-31.26,3.81-51.61c0.34-2.17,0.7-4.12,1.09-5.73 c-8.42-4.54-15.35-9.4-20.49-16.65C42.51,26.31,35.5,13.87,27.96,0H0v263.38h44.29c2.07-7.14,3.92-14.06,5.38-19.42 C53.34,230.5,55.48,218.88,57.01,188.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.27,18.32c6.11,5.5,3.67-8.25,5.81-12.23c0.15-0.27,0.34-0.61,0.57-1c0.24-0.79,0.57-1.42,1.01-1.67l0,0 C84.26,2.45,84.98,1.3,85.8,0H63.2C67.09,8.59,71.49,14.02,76.27,18.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.34,37.43c2.83,5.85,6.83,49.09,7.44,58.52c0,0,0,0,0,0c0.18,1.46,0.36,2.9,0.54,4.32 c3.21,26.37,9.4,100.43,8.94,136.66c-0.12,9.26-0.38,18.12-0.72,26.46h6.83V5.77c-1.18,3.84-3.1,7.84-5.66,11.48 C250.6,27.37,242.72,35.16,240.34,37.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.89,6.7C230.89,6.71,230.89,6.71,230.89,6.7c2.49-3.29,4.37-5.26,5.82-6.7h-7.85c0,0,0,0,0,0 C230,2.26,230.89,6.7,230.89,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.08,119.52c-0.06,0.01-0.12,0.01-0.18,0.01c-3.17,0.58-5.19,0.49-6.36,0.28 c-1.12,6.72-9.99,57.69-28.78,102.43c-7.04,16.77-13.34,30.09-18.8,41.13h76c-6.77-24.46-14.77-52.14-16.83-74.15 C167.38,159.88,165.54,134.65,165.08,119.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.44,3.95c0,0,44.03,16.2,76.74,17.12c32.71,0.92,52.66-0.88,66.69-21.07H85.8 c-0.82,1.3-1.54,2.45-2.14,3.42C85.44,3.95,85.44,3.95,85.44,3.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.32,100.26c-0.17-1.41-0.35-2.86-0.54-4.32c-8.41,0-26.9,1.56-47.39,9.21 c-20.48,7.64-29.27,11.46-34.62,14.22c-0.3,0.06-0.58,0.11-0.87,0.17c0.06-0.01,0.12-0.01,0.18-0.01 c0.46,15.13,2.29,40.36,5.04,69.71c2.06,22.01,10.06,49.69,16.83,74.15h69.59c0.33-8.33,0.6-17.2,0.72-26.46 C257.72,200.69,251.53,126.63,248.32,100.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.57,46.59c0.07-0.31,0.15-0.62,0.23-0.9c8.03,2.98,12.15,5.27,25.68,7.8c13.53,2.52,14.9,5.5,20.87,7.57 c5.96,2.06,10.32,2.52,12.61,2.06c22.7-16.36,11.24-35.47,11.24-35.47c-10.09-2.98-20.87-7.75-34.17-8.04s-16.05-0.63-19.49,0 c-3.44,0.63-4.24,0.63-4.24,0.63s2.52-0.34,3.1-4.7c0.57-4.36,0.57-4.36,0.57-4.36s-0.02-3.77,0.69-6.09 c-0.23,0.39-0.43,0.73-0.57,1c-2.14,3.97,0.31,17.73-5.81,12.23C71.49,14.02,67.09,8.59,63.2,0H27.96 c7.54,13.87,14.56,26.31,17.13,29.94C50.22,37.19,57.15,42.05,65.57,46.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.89,6.71C230.89,6.71,230.89,6.71,230.89,6.71L230.89,6.71c0,0-8.87,7.47-7.57,12.98 c1.3,5.5-4.13,25.77,16.97,17.63c0.02,0.03,0.03,0.08,0.05,0.11c2.38-2.27,10.26-10.06,17.38-20.17 c2.56-3.64,4.48-7.64,5.66-11.48V0h-26.66C235.26,1.44,233.38,3.41,230.89,6.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.75,222.25c18.79-44.74,27.67-95.71,28.78-102.43c-1.01-0.18-1.41-0.45-1.41-0.45 s-27.52-18.5-51.06-22.01c-23.54-3.52-33.94-5.96-44.79-4.89c0-6.85,1.21-27.44,3.2-40.15c-4.32,20.35-3.81,51.61-3.81,51.61 s-2.14,53.81-3.67,84.38c-1.53,30.57-3.67,42.19-7.34,55.64c-1.46,5.36-3.32,12.29-5.38,19.42h66.67 C116.42,252.34,122.71,239.01,129.75,222.25z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "228.86,0 228.86,0 228.86,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.18,21.07C129.47,20.16,85.44,3.95,85.44,3.95s0,0-1.78-0.53l0,0c-0.44,0.24-0.77,0.87-1.01,1.67 c-0.71,2.32-0.69,6.09-0.69,6.09s0,0-0.57,4.36c-0.57,4.36-3.1,4.7-3.1,4.7s0.8,0,4.24-0.63c3.44-0.63,6.19-0.29,19.49,0 s24.08,5.06,34.17,8.04c0,0,11.46,19.11-11.24,35.47c-2.29,0.46-6.65,0-12.61-2.06c-5.96-2.06-7.34-5.04-20.87-7.57 c-13.53-2.52-17.66-4.81-25.68-7.8c-0.08,0.29-0.15,0.59-0.23,0.9c-0.38,1.6-0.75,3.55-1.09,5.73c-1.99,12.7-3.2,33.29-3.2,40.15 c10.85-1.07,21.25,1.38,44.79,4.89c23.54,3.52,51.06,22.01,51.06,22.01s0.4,0.27,1.41,0.45c1.18,0.21,3.19,0.3,6.36-0.28 c0.28-0.05,0.57-0.1,0.87-0.17c5.35-2.75,14.14-6.57,34.62-14.22c20.48-7.64,38.98-9.21,47.39-9.21c0,0,0,0,0,0 c-0.61-9.43-4.62-52.67-7.44-58.52c-0.02-0.03-0.03-0.08-0.05-0.11c-21.1,8.14-15.67-12.13-16.97-17.63 c-1.3-5.5,7.57-12.98,7.57-12.98l0,0c0-0.01-0.89-4.45-2.03-6.7c0,0,0,0,0,0C214.84,20.2,194.89,21.99,162.18,21.07z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.97,145.19c0,0,25.11,48.84,88.75,23.47"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage5);
export default __webpack_public_path__ + "static/media/image5.0d7cd210e7f9f2e6d006acd9b059aa73.svg";
export { ForwardRef as ReactComponent };